import {Component, Input, OnInit} from '@angular/core';
import {CommonModule} from '@angular/common';
import {Aangifte, BokkzIbDataService} from "@snelstart-ventures/fiscaal/domain-logic";
import {SharedUiButtonModule} from "@snelstart/ui-button";

@Component({
  selector: 'snelstart-venture-fiscaal-feature-tekst-premies-lijfrente',
  standalone: true,
  imports: [CommonModule, SharedUiButtonModule],
  templateUrl: './tekst-premies-lijfrente.component.html',
  styleUrl: './tekst-premies-lijfrente.component.scss',
})
export class TekstPremiesLijfrenteComponent implements OnInit {

  @Input() public id!: string;
  public ibAangifte = {} as Aangifte;
  public focusedElementId: string | null = null;
  public year = 2024;
  public actualYear: number = new Date().getFullYear();

  constructor(
      public dataService: BokkzIbDataService) {
  }

  ngOnInit(): void {
    this.dataService.incomeTaxEntity.subscribe((value) => {
      if (value.year !== undefined) {
        this.year = value.year;
      }
    })
  }

}

